/**
 * Thumbnail URL resolution.
 *
 * Slide-search hits carry `link_thumbnail` already (populated by the
 * backend's processSlideSearch). Doc-search hits need a URL derived from
 * `drive_id`; the frontend falls back to a document-type icon via <img
 * onError> if the URL 404s.
 */

const DOC_THUMBNAIL_TEMPLATE =
  "https://storage.cloud.google.com/know-catalog/presentation/{drive_id}/image-01.png";

export function resolveThumbnail(
  mode: "doc-search" | "slide-search",
  hit: Record<string, unknown>,
): string | null {
  if (mode === "slide-search") {
    const url = hit.link_thumbnail;
    return typeof url === "string" ? url : null;
  }
  const driveId = hit.drive_id;
  if (typeof driveId !== "string" || driveId.length === 0) return null;
  return DOC_THUMBNAIL_TEMPLATE.replace("{drive_id}", encodeURIComponent(driveId));
}

export function resolveLink(
  mode: "doc-search" | "slide-search",
  hit: Record<string, unknown>,
): string | null {
  if (mode === "slide-search") {
    const url = hit.link_slide;
    return typeof url === "string" ? url : null;
  }
  const link = hit.link_edit ?? hit.new_url ?? hit.link_view;
  return typeof link === "string" ? link : null;
}

export function resolveTitle(hit: Record<string, unknown>): string {
  const title = hit.title;
  if (typeof title === "string" && title.trim().length > 0) return title;
  return "(untitled)";
}
